import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Snackbar, Stack } from '@mui/material';
import { RootState } from '../../store';
import { removeNotification } from '../../store/slices/uiSlice';

const NotificationSystem: React.FC = () => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state: RootState) => state.ui);

  const handleClose = (id: string) => {
    dispatch(removeNotification(id));
  };

  // Auto-remove notifications after their duration
  useEffect(() => {
    if (notifications.length > 0) {
      notifications.forEach((notification) => {
        const { id, duration = 6000 } = notification;
        const timer = setTimeout(() => {
          dispatch(removeNotification(id));
        }, duration);

        // Clear timeout on unmount or when notification is removed manually
        return () => clearTimeout(timer);
      });
    }
  }, [notifications, dispatch]);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 2000,
        maxWidth: '100%',
        width: {
          xs: 'calc(100% - 32px)',
          sm: 400,
        },
      }}
    >
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'static', mb: 2 }}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.type}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default NotificationSystem; 